import { Box, Typography } from '@packages/shared';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import type { OverlayCircleType } from './types';

/**
 * This component shows editorial content of a teaser.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const OverlayCircleItem = ({ data }: { data: OverlayCircleType }) => {
  const {
    field_text_01: text01,
    field_text_02: text02,
    field_text_03: text03,
    behavior_paragraph_invert_font_color: styleIsNegativeTextColor = false,
  } = data;

  return (
    <Box
      sx={{
        display: 'flex',
        color: styleIsNegativeTextColor ? 'text.dark' : 'text.light',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        lineHeight: {
          xs: '0.875rem',
          md: '1.688rem',
        },
        '& .soft-hyphen-injector': {
          position: 'relative',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'inline-block',
        },
      }}
      component="div"
    >
      {text01 && (
        <Typography
          component="div"
          sx={{
            fontSize: {
              xs: '0.75rem',
              md: '1.25rem',
            },
            lineHeight: {
              xs: '0.875rem',
              md: '1.688rem',
            },
          }}
        >
          <SoftHyphenInjector text={text01} />
        </Typography>
      )}
      {text02 && (
        <Typography
          component="div"
          sx={{
            fontSize: {
              xs: '2.563rem',
              md: '5.313rem',
            },
            lineHeight: {
              xs: '2.563rem',
              md: '5.75rem',
            },
          }}
        >
          <SoftHyphenInjector text={text02} />
        </Typography>
      )}
      {text03 && (
        <Typography
          component="div"
          sx={{
            fontSize: {
              xs: '0.75rem',
              md: '1.25rem',
            },
            lineHeight: {
              xs: '0.875rem',
              md: '1.688rem',
            },
          }}
        >
          <SoftHyphenInjector text={text03} />
        </Typography>
      )}
    </Box>
  );
};
